import { render, staticRenderFns } from "./orgNotificationFromEmail.vue?vue&type=template&id=2bf824fc&scoped=true&"
import script from "./orgNotificationFromEmail.vue?vue&type=script&lang=js&"
export * from "./orgNotificationFromEmail.vue?vue&type=script&lang=js&"
import style0 from "./orgNotificationFromEmail.vue?vue&type=style&index=0&id=2bf824fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf824fc",
  null
  
)

export default component.exports